import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { RulesActions } from '../../../redux/Rules';

const Styled = styled.button`
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid #302220;
  border-radius: 4px;
  background-color: #231717;
  color: #d2c8ae;
  padding: 0.2em 2rem;
  min-height: 38px;
  margin-bottom: 1em;
  font-size: 18px;
`;

const Rule = ({ rule, canRoll }) => {
  const dispatch = useDispatch();
  const disabled = rule.sticky || !canRoll;
  const text = () => {
    return (
      <div>
        {!disabled ? <span>@ </span> : ''}
        <span>{rule.ruleString}</span>
      </div>
    );
  };
  return (
    <Styled
      title={rule.description}
      disabled={disabled}
      onClick={() => dispatch(RulesActions.rollRule(rule))}
    >
      {text()}
    </Styled>
  );
};

Rule.propTypes = {
  rule: PropTypes.objectOf(PropTypes.string),
  canRoll: PropTypes.bool,
};

export default Rule;
